import React, { createContext, useState, useContext, useEffect } from 'react';
import { supabase } from './auth/supabaseClient';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isPaidUser, setIsPaidUser] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [accessToken, setAccessToken] = useState(null); 

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUser(user.user_metadata);
        setClientId(user.id);
      } else {
        setUser(null);
        setClientId(null);
      }
    };

    const fetchPaid = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (!session) return; // Exit if there's no active session
    
      const { data, paid_error } = await supabase
        .from('user_payments')
        .select('paid, subscription_id')
        .eq('UID', session.user.id)
        .single();
        
      if (data) {
        setIsPaidUser(data.paid === 1);
        if (data.paid === 1) {
          setSubscriptionId(data.subscription_id);
        }
      }
    };

    const fetchAccessToken = async () => {
      const { data: { session }, error } = await supabase.auth.refreshSession();
      if (!session) return; // Exit if there's no active session
       
      let accessToken = session.access_token;
      setAccessToken(accessToken);
    }

    fetchUser();
    fetchPaid();
    fetchAccessToken();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user?.user_metadata ?? null);
      if (session?.access_token) {
        setAccessToken(session.access_token);
      }
    });

    return () => {
      authListener?.unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{user, isPaidUser, subscriptionId, clientId, accessToken}}>
      {children}
    </UserContext.Provider>
  );
};
